const FTUEKeys = {
    COMMUNITY_ONBOARADING: 'community/onboarding',
    COMMUNITY_QUESTION_GUIDELINES: 'community/question_guidelines',
    COMMUNITY_ANSWER_GUIDELINES: 'community/answer_guidelines',
    COMMUNITY_QUESTION_REPLY_GUIDELINES: 'community/question_reply_guidelines',
    COMMUNITY_ANSWER_REPLY_GUIDELINES: 'community/answer_reply_guidelines',
    COMMUNITY_FIRST_QUESTION_READ: 'community/first_question_read',
    COMMUNITY_FIRST_QUESTION_READ_AS_AUTHOR: 'community/first_question_read_as_author',
    COMMUNITY_QUESTION_VOTING_GUIDELINES: 'community/question_voting_guidelines',
    COMMUNITY_ANSWER_VOTING_GUIDELINES: 'community/answer_voting_guidelines',
    COMMUNITY_QUESTIONS_NEEDING_HELP_FILTER_EXPLANATION: 'community/questions_needing_help_filter_explanation',
    COMMUNITY_TOPICS_GROUP_FILTER_EXPLANATION: 'community/topics_group_filter_explanation',
    PLAYLIST_INTRODUCTION: 'playlist/introduction',
    EP_QP_UPLOAD_INTRO: 'ep/qp/upload/introudction',
    IMG2TXT_INTRODUCTION: 'img2txt/introduction',
};
export default FTUEKeys;
